import { registerKhmerFont } from '@mts/utils/registerKhmerFont';

registerKhmerFont();

export const registeAppEvents = () => {};

export const registeUserAppEvents = () => {};
